import React from 'react';
import NetworkIntelligencePage from '../../features/network-intelligence/pages/NetworkIntelligencePage';

const AdminNetworkIntelligence = () => <NetworkIntelligencePage />;

export default AdminNetworkIntelligence;


